import { Container, StyledFlex } from '@tryhackme/thm-ui-components';
import { SEO } from 'src/common/components';
import { MagicLoginForm } from 'src/features/login/components/magic-login-form';
export const MagicLoginPage = () => <section data-sentry-component="MagicLoginPage" data-sentry-source-file="magic-login-page.tsx">
    <SEO title="Login" description="TryHackMe is a free online platform for learning cyber security, using hands-on exercises and labs, all through your browser!" data-sentry-element="SEO" data-sentry-source-file="magic-login-page.tsx" />
    <Container data-sentry-element="Container" data-sentry-source-file="magic-login-page.tsx">
      <StyledFlex flexDirection="column" data-sentry-element="StyledFlex" data-sentry-source-file="magic-login-page.tsx">
        <MagicLoginForm data-sentry-element="MagicLoginForm" data-sentry-source-file="magic-login-page.tsx" />
      </StyledFlex>
    </Container>
  </section>;